<template>
    <component
        :is="productCheckoutTemplate"
        v-bind="templateProps"
    >

    </component>
</template>

<script>
    import PreviewComponent from "./PreviewComponent";
    import ProductCheckoutComponent from "../../components/pagesbuilder/dynamic-components/ProductCheckoutComponent";
    import ProductCheckoutTemplate1 from "../../author/pagesbuilder/templates/cards/ProductCheckoutTemplate1";

    export default {
        name: "PreviewProductCheckoutComponent",
        mixins: [PreviewComponent, ProductCheckoutComponent],
        components: {
            ProductCheckoutTemplate1
        }
    }
</script>

